import React, { useState } from 'react';
import ProjectScopeApproval from '../../components/admin/Approvals/ProjectScopeApproval';
import AccountApproval from '../../components/admin/Approvals/AccountApproval';
import DurationOverrideApproval from '../../components/admin/Approvals/DurationOverrideApproval';
import styles from './Approvals.module.css';

const Approvals = () => {
  const [activeTab, setActiveTab] = useState('scopes');

  return (
    <div className={styles.approvalsPage}>
      <h1>Approvals</h1>

      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === 'scopes' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('scopes')}
        >
          Project Scopes
        </button>
        {/* <button
          className={`${styles.tab} ${activeTab === 'milestones' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('milestones')}
        >
          Milestones
        </button> */}
        <button
          className={`${styles.tab} ${activeTab === 'milestones' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('milestones')}
        >
          Account Approvals
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'duration-overrides' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('duration-overrides')}
        >
          Duration Reviews
        </button>
      </div>

      <div className={styles.tabContent}>
        {activeTab === 'scopes' && <ProjectScopeApproval />}
        {/* {activeTab === 'milestones' && <MilestoneApprovalSection />} */}
         {activeTab === 'milestones' && <AccountApproval />}
        {activeTab === 'duration-overrides' && <DurationOverrideApproval />}
      </div>
    </div>
  );
};

export default Approvals;